module.exports = __webpack_public_path__ + "static/media/worry-free-1.6368049e.png";